'use client';

import {Suspense} from 'react';
import {useSearchParams} from 'next/navigation';
import CartComponent from './_cart';
import CartGroup from './group-cart';

const Page = () => {
  const searchParams = useSearchParams();
  const active = searchParams.get('active') ?? 'cart';

  return (
    <Suspense>
      <div className="">
        {active === 'cart' ? <CartComponent /> : <CartGroup />}
      </div>
    </Suspense>
  );
};

export default Page;
